import { render, staticRenderFns } from "./ChangeRejectBranch.vue?vue&type=template&id=5f73b668&scoped=true"
import script from "./ChangeRejectBranch.vue?vue&type=script&lang=js"
export * from "./ChangeRejectBranch.vue?vue&type=script&lang=js"
import style0 from "./ChangeRejectBranch.vue?vue&type=style&index=0&id=5f73b668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f73b668",
  null
  
)

export default component.exports